const RecommendedAmoutRemarks = ({ text }) => {
  if (!text) return <p>N/A</p>;

  const parts = text.split("|").map((p) => p.trim());
  return (
    <div className="space-y-2 text-sm">
      <p className="font-semibold text-test-theme-color">
        Recommended Investment Updated
      </p>
      <ul className="list-disc list-inside space-y-1">
        {parts.map((part, idx) => (
          <li key={idx} className="leading-snug">
            {part}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecommendedAmoutRemarks;
